import HRNumbers from 'human-readable-numbers';
import { Spinner } from "modules/common/components";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import {
    CountData,
    ResponsiveBox,
    StateData,
    TextDataa
} from '../styles/main';

export class LiveChatState extends Component {
    constructor(props) {
        super(props);
    }

    // Helper function to format keys to title case
    formatKey = (key) => {
        return key
            .split(/(?=[A-Z])|_/g) // Split camelCase or snake_case
            .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
            .join(' ');
    }

    render() {
        const { list } = this.props;

        if (!list) {
            return <Spinner />;
        }

        return (
            // <Row className='w-100'>
            //     {Object.keys(list).length > 0 && Object.keys(list).map((key) => {
            //         return (
            //             <ResponsiveBox key={key}>
            //                 <StateData>
            //                     <TextDataa>{this.formatKey(key)}</TextDataa>
            //                     <CountData>{HRNumbers.toHumanString(list[key] || 0)}</CountData>
            //                 </StateData>
            //             </ResponsiveBox>
            //         );
            //     })}
            // </Row>
            <Row className='w-100'>
                {Object.keys(list).length > 0 &&
                    Object.keys(list)
                        .filter((key) => key !== 'closed') // Exclude "closed" key
                        .sort((a, b) => (a === 'totalActiveSession' ? -1 : b === 'totalActiveSession' ? 1 : 0)) // Prioritize "totalActiveSession"
                        .map((key) => {
                            const displayKey = key === 'totalActiveSession' ? 'Active Session' : this.formatKey(key); // Rename totalActiveSession to Active Session
                            return (
                                <ResponsiveBox key={key}>
                                    <StateData>
                                        <TextDataa>{displayKey}</TextDataa>
                                        <CountData>{HRNumbers.toHumanString(list[key] || 0)}</CountData>
                                    </StateData>
                                </ResponsiveBox>
                            );
                        })}
            </Row>

        );
    }
}

LiveChatState.contextTypes = {
    __: PropTypes.func
};

export default LiveChatState;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/LiveChatState.js